import { Delete, Get, getAPIUrl, Post, Put } from "../../apiMethods";

export const ItemEndpoint = {
  createCategory: "restaurant/category/create-category",
  fetchCategory: "restaurant/category/fetch-category",
  addItem: "restaurant/food/add-item",
  getItems: "restaurant/food/item",
  updateItems: "restaurant/food/update-item",
  updateCategories: "restaurant/category",
 // EditCategory: "restaurant/category/update",
  groupOrder: "restaurant/group-order/qr-scan",
  brandlist: "vendor/restaurant-branding/restaurant/",
};

const isCustomerRoute = () => {
  const path = window.location.pathname || "";
  const hash = window.location.hash || "";
  return (
    path.includes("customer") ||
    hash.includes("/single-or-group") ||
    hash.includes("/order-by-customer") ||
    hash.includes("/customer/")
  );
};

export const CreateCatehory = (data, param = "") => {
  const url = getAPIUrl(ItemEndpoint.createCategory, param);
  return Post(url, data);
};
export const fetchCategory = (param = "") => {
  const url = getAPIUrl(
    isCustomerRoute()
      ? "restaurant/customer/fetch-category"
      : ItemEndpoint.fetchCategory,
    param
  );
  return Get(url);
};
export const fetchGalleryImage = (param = "") => {
  const url = getAPIUrl(
    ItemEndpoint.fetchGalleryImage,
    param
  );
  return Get(url);
};
export const AddItems = (data, param = "") => {
  const url = getAPIUrl(ItemEndpoint.addItem, param);
  return Post(url, data);
};
export const getItems = (param = "") => {
  const url = getAPIUrl(
    isCustomerRoute()
      ? "restaurant/customer/item"
      : ItemEndpoint.getItems,
    param
  );
  return Get(url);
};
export const GroupOrder = (data, param = "") => {
  const url = getAPIUrl(ItemEndpoint.groupOrder, param);
  return Post(url, data);
};
export const UpdateItems = (data, param = "") => {
  const url = getAPIUrl(ItemEndpoint.updateItems, param);
  return Put(url, data);
};
// export const EditCategory = (data, param = "") => {
//   const url = getAPIUrl(ItemEndpoint.EditCategory, param);
//   return Put(url, data);
// };
export const updateCategories = (data, param = "") => {
  const url = getAPIUrl(ItemEndpoint.updateCategories, param);
  return Delete(url, data);
};

export const getBrand = (param = "") => {
  const url = getAPIUrl(ItemEndpoint.brandlist, param);
  return Get(url);
};
